// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"c0460c0a9f91e917b8e4","532":"66401135a531aed5b97c","691":"e2e27066d54f722e9b22"}[chunkId] + ".js";
};